export const FIELD_EMPTY_ERROR = 'Field should not be empty!';
export const PASSWORD_MATCH_ERROR = 'Passwords should match!';
export const PASSWORD_VALIDATION_ERROR =
  'Password must be minimum 8 characters with at least one uppercase letter, one lowercase letter, one number and one special character.';
export const PASSWORD_RESET_SUCCESS = 'Your password has been reset.';
export const PASSWORD_SET_SUCCESS = 'Your password has been set.';
export const EMAIL_CONFIRM_SUCCESS = 'You have successfully confirmed your email.';
